import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'
const appUrl = process.env.VUE_APP_BASE_URL
const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/bulk-payouts`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/bulk-payouts`
const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl

export async function getBulkPayoutsService (payload) {
  const hasSearch = payload.search ? `&search=${payload.search}` : ''
  const hasFrom = payload.from ? `&from=${payload.from}` : ''
  const currency = payload.currency ? payload.currency : ''
  const hasTo = payload.to ? `&to=${payload.to}` : ''
  const res = await axios.get(
    `${baseUrl}?status=${payload.status}&type=${payload.type}&page=${payload.page}&size=${payload.size}&currency=${payload.currency}${hasSearch}${hasFrom}${hasTo}`,
    {}
  )
  return res
}

export async function initiateBulkPayoutService (payload) {
  const res = await axios.post(`${baseUrl}/upload`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return res
}
export async function getBulkPayoutConfigService (payload) {
  const hasCurrency = payload.currency ? `?currency=${payload.currency}` : ''
  const hasPaymentMethod = payload.type ? `&type=${payload.type}` : ''
  const res = await axios.get(
    `${baseUrl}/config${hasCurrency}${hasPaymentMethod}`,
    {}
  )
  return res
}
export async function saveBeneficiaryService (payload) {
  const res = await axios.post(`${appUrl}/transfers/create-beneficiary`, {
    ...payload
  })
  return res
}
export async function getPayoutBeneficiariesService (payload) {
  const res = await axios.get(
    `${appUrl}/transfers/beneficiaries?page=${payload.page}&size=${payload.size}&destination_currency=${payload.currency}`
  )
  return res
}
export async function initiateSinglePayoutService (payload) {
  const res = await axios.post(`${baseUrl}`, {
    ...payload
  })
  return res
}
export async function getBulkPayoutService (payload) {
  const res = await axios.get(
    `${baseUrl}/${payload.id}?page=${payload.page}&size=${payload.size}`,
    {}
  )
  return res
}
export async function cancelBulkPayoutService (payload) {
  const res = await axios.post(`${baseUrl}/cancel`, {
    ...payload
  })
  return res
}
export async function updatePayoutService (payload) {
  const res = await axios.put(`${baseUrl}/accounts/${payload.id}`, {
    ...payload.formData
  })
  return res
}
export async function toggleRecurringBulkPayoutService (payload) {
  const res = await axios.post(`${baseUrl}/toggle-recurring`, {
    ...payload
  })
  return res
}
export async function getBulkPayoutLogsService (payload) {
  const res = await axios.get(
    `${baseUrl}/logs/${payload.bulkPayoutId}?page=${payload.page}&size=${payload.size}`,
    {}
  )
  return res
}
export async function getSupportedPayoutBanksService (payload) {
  const res = await axios.get(
    `${appUrl}/utils/supported-banks?currency=${payload.currency}&payoutType=${payload.payoutType}`
  )
  return res
}
export async function approveDisapproveBulkPayoutService (payload) {
  const res = await axios.post(
    `${appUrl}/transactions/requests/process`,
    payload
  )
  return res
}
export async function retryBulkPayoutService (logId, payload) {
  const res = await axios.post(
    `${baseUrl}/retry/${logId}?twoFaCode=${payload?.twoFaCode}`
  )
  return res
}
